<template>
  <div :class="{ collapsed: collapsed }">
    <SuperAdminSidebar/>
    <div class="sidebar-offset" :class="{ collapsed: collapsed }">
      <SuperAdminHeader/>
      <main>
        <div class="dentist-container">
          <slot/>
        </div>
      </main>
    </div>
    <div class="mobile-shadow" @click="$store.commit('toggleCollapsed')"></div>
    <FormModal v-if="showModal"/>
<!--    <SuperAdminLaravelEcho/>-->
  </div>
</template>
<script setup>
import FormModal from "@/components/parts/datatable/FormModal"
import SuperAdminHeader from "@/components/layouts/SuperAdminHeader"
import SuperAdminSidebar from "@/components/layouts/SuperAdminSidebar"
// import SuperAdminLaravelEcho from "@/components/parts/superadmin/SuperAdminLaravelEcho"
import { computed } from "vue"
import { useStore } from "vuex"

const store = useStore()

const collapsed = computed(() => store.state.dom.sidebarCollapsed)
const showModal = computed(() => store.state.datatable.showModal)
</script>
